"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByNumberField = exports.sortByTextFieldCaseInsensitive = exports.SortOrder = void 0;
const ramda_1 = require("ramda");
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["Ascend"] = 0] = "Ascend";
    SortOrder[SortOrder["Descend"] = 1] = "Descend";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
const sortOrderToComparatorFunctionMap = {
    [SortOrder.Ascend]: ramda_1.ascend,
    [SortOrder.Descend]: ramda_1.descend,
};
const sortBy = (list, { propName, sortOrder = SortOrder.Ascend, parser }) => {
    const comparator = sortOrderToComparatorFunctionMap[sortOrder];
    return (0, ramda_1.sort)(comparator((0, ramda_1.compose)(parser, (0, ramda_1.prop)(propName))), list);
};
const sortByTextFieldCaseInsensitive = (sortOrder) => (list, propName) => sortBy(list, { propName, sortOrder, parser: ramda_1.toLower });
exports.sortByTextFieldCaseInsensitive = sortByTextFieldCaseInsensitive;
const sortByNumberField = (sortOrder) => (list, propName) => sortBy(list, { propName, sortOrder, parser: Number });
exports.sortByNumberField = sortByNumberField;
